import React, { useState } from 'react';
import styles from './MfAddComposition.module.css';
import MfSelectComp from './MfSelectComp';
import MfCreateNewComp from './MfCreateNewComp';
import { useMfImport } from 'features/compositions/context/MfImportContext';

const MfAddComposition = () => {
    const [tab, setTab] = useState(1);
    const { exist, setExist, setSelectedComposition } = useMfImport();

    const existing = () => {
        setTab(1);
        setExist(true);
        setSelectedComposition('');
    }

    const createNew = () => {
        setTab(2);
        setExist(false);
        setSelectedComposition('');
    }
    return (
        <div className={styles.mf_add_composition}>
            <div className={styles.select_tab}>
                <button className={tab === 1 ? styles.active : ''} onClick={() => existing()}>Use existing composition</button>
                <button className={tab === 2 ? styles.active : ''} onClick={() => createNew()}>Create new composition</button>
            </div>
            {tab === 1 && <MfSelectComp />}
            {tab === 2 && <MfCreateNewComp />}
        </div>
    )
}

export default MfAddComposition;